export default __webpack_public_path__ + "static/media/breakfast3.6d0da81b.png";